import {
  Box,
  Card,
  CircularProgress,
  Grid,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import * as ajax from '../../../ajax';
import Pending from '../../../components/Communication';
import Container from '../../../components/Container';
import InfluencerProfileOverviewCard from '../../../components/InfluencerProfileOverviewCard';
import useRequest from '../../../hooks/use-request';
import { getUserFeatures } from '../../../store/models/user/user.selectors';
import selectors from '../../../store/selectors';
import through from '../../../utils/through';

export default function Overview() {
  document.title = 'Overview';

  const { t } = useTranslation();

  const features = useSelector(getUserFeatures);
  const { organization_id } = useSelector(selectors.getUser);

  const {
    data: recommendedResult,
    succeeded: influencersSucceeded,
    init: initInfluencers,
  } = useRequest(ajax.getRecommendedInfluencers);

  const { results } = recommendedResult || {};

  const [influencers, setInfluencers] = useState(null);

  const [isRequestRunning, setIsRequestRunning] = useState(false);

  useEffect(() => setInfluencers(results?.results), [results]);

  useEffect(() => {
    if (organization_id) {
      initInfluencers(organization_id, { limit: 6, organization_id });
    }
  }, [organization_id]);

  return (
    <Container>
      <Grid container spacing={4} direction="column">
        {features.discovery !== false && (
          <>
            <Grid item>
              <Typography variant="h2">
                {t('overview.discovery.title')}
              </Typography>
            </Grid>
            <Grid item>
              <Grid container spacing={4}>
                <Pending
                  ready={influencersSucceeded && Array.isArray(influencers)}
                  fallback={through(0, 3).map((i) => (
                    <Grid item xs={12} sm={6} md={4} key={i}>
                      <Box
                        clone
                        height={400}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Card>
                          <CircularProgress />
                        </Card>
                      </Box>
                    </Grid>
                  ))}
                >
                  {() =>
                    influencers?.map((influencer, i) =>
                      influencer ? (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          key={influencer.login}
                        >
                          <InfluencerProfileOverviewCard
                            {...influencer}
                            influencers={influencers}
                            setInfluencers={setInfluencers}
                            organization_id={organization_id}
                            isRequestRunning={isRequestRunning}
                            setIsRequestRunning={setIsRequestRunning}
                          />
                        </Grid>
                      ) : (
                        <Grid item xs={12} sm={6} md={4} key={i}>
                          <Box
                            clone
                            height={345}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Card>
                              <CircularProgress />
                            </Card>
                          </Box>
                        </Grid>
                      )
                    )
                  }
                </Pending>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </Container>
  );
}
